<template>
  <v-dialog
    :value="true"
    persistent
    width="250"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-title class="py-6 text-center">
        {{ $t(messageKey) }}
        <v-progress-linear
          indeterminate
          color="white"
        />
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    messageKey: {
      type: String,
      default: 'TaskList.eSigning'
    }
  }
}
</script>
